import React from 'react';
import { IconProps } from './types';

const Google: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => {
  const fill = !ignoreColor ? color : undefined;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M7.838.547c-2.485.834-4.603 2.656-5.782 4.962a9.767 9.767 0 00-.889 2.516 9.854 9.854 0 00.883 6.466 10.133 10.133 0 002.77 3.339 10.248 10.248 0 003.71 1.833c1.7.446 3.51.435 5.222.053 1.546-.35 3.011-1.075 4.18-2.128 1.234-1.113 2.117-2.575 2.583-4.15.51-1.715.576-3.548.258-5.311h-9.6v3.902h5.563a4.703 4.703 0 01-2.041 3.091 5.913 5.913 0 01-2.25.871c-.8.134-1.634.15-2.435-.005a6.107 6.107 0 01-2.27-.962 6.195 6.195 0 01-2.338-3.07 5.952 5.952 0 010-3.892 6.225 6.225 0 011.481-2.36 6.086 6.086 0 013.05-1.66 6.208 6.208 0 012.996.118c.822.242 1.58.688 2.2 1.268l1.876-1.838c.329-.328.674-.645.992-.984A9.984 9.984 0 0014.711.612 10.498 10.498 0 007.838.547z"
        fill={fill}
      />
      <path
        d="M7.838.547a10.533 10.533 0 016.874.06A9.95 9.95 0 0117.998 2.6c-.319.338-.664.656-.993.983l-1.876 1.839a5.583 5.583 0 00-2.2-1.269 6.143 6.143 0 00-2.995-.118 6.132 6.132 0 00-3.05 1.661 6.185 6.185 0 00-1.482 2.36c-1.113-.85-2.227-1.693-3.346-2.543C3.236 3.203 5.353 1.381 7.838.547z"
        fill={fill}
      />
      <path
        d="M1.173 8.02c.18-.872.477-1.721.889-2.517 1.113.85 2.227 1.694 3.346 2.543a5.917 5.917 0 000 3.892c-1.114.85-2.227 1.698-3.341 2.542a9.77 9.77 0 01-.894-6.46zM11.174 8.121h9.6c.318 1.758.246 3.591-.258 5.311-.467 1.575-1.35 3.037-2.584 4.15l-3.242-2.467a4.703 4.703 0 002.04-3.091h-5.562c.006-1.3.006-2.602.006-3.903z"
        fill={fill}
      />
      <path
        d="M2.056 14.486c1.113-.844 2.227-1.693 3.34-2.543a6.227 6.227 0 002.337 3.07c.68.467 1.46.8 2.272.962.8.161 1.629.14 2.435.005.801-.14 1.575-.424 2.25-.87l3.241 2.467c-1.168 1.059-2.633 1.78-4.18 2.128-1.711.382-3.522.393-5.222-.053a10.162 10.162 0 01-3.709-1.833 10.11 10.11 0 01-2.764-3.333z"
        fill={fill}
      />
    </svg>
  );
};

export default Google;
